import { __awaiter, __generator } from "tslib";
import React, { useEffect } from 'react';
import { composer } from '../../../component-decorators/composer';
import More from 'wix-ui-icons-common/More';
import AddSmall from 'wix-ui-icons-common/AddSmall';
import ArrowRightSmall from 'wix-ui-icons-common/ArrowRightSmall';
import EditSmall from 'wix-ui-icons-common/EditSmall';
import Pause from 'wix-ui-icons-common/Pause';
import UnlinkSmall from 'wix-ui-icons-common/UnlinkSmall';
import LinkSmall from 'wix-ui-icons-common/LinkSmall';
import HiddenSmall from 'wix-ui-icons-common/HiddenSmall';
import InfoCircleSmall from 'wix-ui-icons-common/InfoCircleSmall';
import EmailSmall from 'wix-ui-icons-common/EmailSmall';
import DeleteSmall from 'wix-ui-icons-common/DeleteSmall';
import Play from 'wix-ui-icons-common/Play';
import FavoriteSmall from 'wix-ui-icons-common/FavoriteSmall';
import { appHasEditor, canUsePremiumApp, enableDeleteMLApp, getAppCheckStatusUrl, getAppSettingsPageUrl, getEditorWebComps, isBundleApp, isBundleAppAndNotInstalled, isEmbeddedScriptApp, isPermittedToDelete, isWixApp, openSettingsUrl, shouldShowAddAgain, wixChatBotLink, } from '../../../utils/appUtils';
import { EditorType, embeddedScriptAppStatus, } from '../../manage-installed-apps-page';
import { ModalNames } from '../../modals/modals';
import { sendContextMenuActionBi, sendDeletePendingAppClickBi, sendOpenContextMenuBi, } from '../../../bi/biEvents';
import { IconButton, PopoverMenu } from 'wix-style-react';
import { getReviewesBySolutionId } from '../../../api';
import { AppGroup, } from '@wix/ambassador-marketplace/types';
export var openStatusUrl = function (app, getAppInstance, openModal) {
    var url = getAppCheckStatusUrl(app);
    var appInstance = app.instance;
    var innerUrl = url.includes('?')
        ? url + "&instance=" + appInstance
        : url + "?instance=" + appInstance;
    openModal(ModalNames.APP_STATUS, { app: app, checkStatusUrl: innerUrl });
};
var sentSupportMail = function (app, origin, msId, openModal, experiments) {
    var shouldOpenSupportModal = experiments.enabled('specs.marketplace.manage-apps.support-modal') ||
        experiments.enabled("specs.marketplace.support-modal-for-" + app.webSolutionBase.id);
    var mailsArray = app.supportEmails;
    var mailsString = mailsArray.join(';');
    var madeByWix = app.webSolutionBase &&
        app.webSolutionBase.company &&
        isWixApp(app.webSolutionBase.company.id);
    if (madeByWix) {
        window.open(wixChatBotLink);
    }
    else if (!shouldOpenSupportModal) {
        if (window) {
            window.location.href = 'mailto:' + mailsString;
        }
    }
    else {
        openModal(ModalNames.SUPPORT, { app: app });
    }
};
var dismissBundleApp = function (appId, deleteAppFromBundle) {
    localStorage.setItem("dismissed-" + appId, 'dismissed');
    deleteAppFromBundle(appId);
};
var getEmbeddedIcon = function (appDefId, status) {
    var appStatus = status[appDefId].status;
    return appStatus === embeddedScriptAppStatus.ENABLED ? React.createElement(Pause, null) : React.createElement(Play, null);
};
var getSmallEmbeddedIcon = function (appDefId, status) {
    var appStatus = status && status[appDefId].status;
    return appStatus === embeddedScriptAppStatus.ENABLED ? (React.createElement(UnlinkSmall, null)) : (React.createElement(LinkSmall, null));
};
var getNewEmbeddedKey = function (appDefId, status) {
    var appStatus = status && status[appDefId].status;
    return appStatus === embeddedScriptAppStatus.ENABLED
        ? 'manage-apps.context-menu.pause'
        : 'manage-apps.context-menu.resume';
};
var getEmbeddedKey = function (appDefId, status) {
    var appStatus = status[appDefId].status;
    return appStatus === embeddedScriptAppStatus.ENABLED
        ? 'manage-apps.context-menu.disable'
        : 'manage-apps.context-menu.enable';
};
var toggleEmbeddedStatus = function (app, embeddedScriptAppsStatus, updateEmbeddedScriptAppsStatus, getAppInstance, openModal) {
    var status = embeddedScriptAppsStatus[app.webSolutionBase.id].status ||
        embeddedScriptAppStatus.DISABLED;
    if (status === embeddedScriptAppStatus.ENABLED) {
        updateEmbeddedScriptAppsStatus(app.webSolutionBase.id, embeddedScriptAppStatus.DISABLED, app.instanceId, embeddedScriptAppsStatus);
    }
    else if (status === embeddedScriptAppStatus.DISABLED) {
        updateEmbeddedScriptAppsStatus(app.webSolutionBase.id, embeddedScriptAppStatus.ENABLED, app.instanceId, embeddedScriptAppsStatus);
    }
    else if (getAppSettingsPageUrl(app)) {
        openSettingsUrl(app, openModal, embeddedScriptAppsStatus);
    }
};
var getDeleteTextKey = function (app, experiments, editorType) {
    if (!appHasEditor(app) ||
        getEditorWebComps(app).length > 0 ||
        app.group === AppGroup.PENDING ||
        (editorType === EditorType.EDITOR &&
            app.webSolutionBase.id !== '14d84998-ae09-1abf-c6fc-3f3cace5bf19') ||
        experiments.enabled('specs.marketplace.delete-all-apps') ||
        enableDeleteMLApp(app, experiments)) {
        return 'manage-apps.context-menu.delete';
    }
    return 'manage-apps.context-menu.how-to-delete';
};
var handleDeleteApp = function (app, openModal, origin, msid, deleteApp, editorType) {
    if (app.group === AppGroup.PENDING) {
        sendDeletePendingAppClickBi(app, origin, msid, editorType);
        deleteApp(app, false);
    }
    else {
        openModal(ModalNames.DELETE, { app: app });
    }
};
var openPostRateModal = function (app, openModal) {
    openModal(ModalNames.RATE_APP, { app: app });
};
var openEditRateModal = function (app, openModal) {
    openModal(ModalNames.EDIT_REVIEW, { app: app });
};
var getSupportText = function (experiments, mail, t, id) {
    return experiments.enabled('specs.marketplace.manage-apps.support-modal') ||
        experiments.enabled("specs.marketplace.support-modal-for-" + id)
        ? t('manage-apps.context-menu.support-cta2')
        : mail;
};
export var ContextMenuButton = composer()
    .withTranslation()
    .withPermissions()
    .withExperiments()
    .compose(function (_a) {
    var t = _a.t, app = _a.app, origin = _a.origin, msid = _a.msid, addAppAgain = _a.addAppAgain, getAppInstance = _a.getAppInstance, updateEmbeddedScriptAppsStatus = _a.updateEmbeddedScriptAppsStatus, embeddedScriptAppsStatus = _a.embeddedScriptAppsStatus, openModal = _a.openModal, baseUrl = _a.baseUrl, permissions = _a.permissions, experiments = _a.experiments, gotoWebSolutionPage = _a.gotoWebSolutionPage, deleteApp = _a.deleteApp, siteIsPremium = _a.siteIsPremium, editorType = _a.editorType, isActionRequiredApp = _a.isActionRequiredApp, openApp = _a.openApp, deleteAppFromBundle = _a.deleteAppFromBundle;
    // @ts-ignore
    var _b = React.useState(undefined), userReview = _b[0], setUserReview = _b[1]; // eslint-disable-line
    var getReviews = function () { return __awaiter(void 0, void 0, void 0, function () {
        var reviews, review;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getReviewesBySolutionId(baseUrl, app.webSolutionBase.id)];
                case 1:
                    reviews = _a.sent();
                    review = reviews.body && reviews.body.userReview
                        ? reviews.body.userReview
                        : undefined;
                    setUserReview(review);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getReviews()
            .then()
            .catch();
    }, []);
    var editReview = !!userReview;
    var PopoverMenuClick = function () {
        sendOpenContextMenuBi(app, origin, msid, editorType);
        getReviews()
            .then()
            .catch();
    };
    var madeByWix = app.webSolutionBase &&
        app.webSolutionBase.company &&
        isWixApp(app.webSolutionBase.company.id);
    return isBundleAppAndNotInstalled(app) ? (React.createElement("div", { onClick: function (e) { return PopoverMenuClick(); } },
        React.createElement(PopoverMenu, { appendTo: 'parent', placement: "left", dataHook: "manage-apps-context-menu", textSize: "small", triggerElement: React.createElement(IconButton, { skin: "inverted", priority: "primary", size: "tiny", dataHook: "manage-apps-more-button" },
                React.createElement(More, null)) },
            React.createElement(PopoverMenu.MenuItem, { skin: "dark", key: 'manage-apps-context-menu-dismiss-bundle', prefixIcon: React.createElement(HiddenSmall, null), dataHook: "manage-apps-manage-apps-context-menu-open-menu-dismiss-bundle", text: t('manage-apps.context-menu.hide'), onClick: function () {
                    sendContextMenuActionBi(app, origin, msid, 'dismiss-bundle', editorType);
                    dismissBundleApp(app.webSolutionBase.id, deleteAppFromBundle);
                } })))) : (React.createElement("div", { onClick: function (e) { return PopoverMenuClick(); } },
        React.createElement(PopoverMenu, { appendTo: 'parent', placement: "left", dataHook: "manage-apps-context-menu", textSize: "small", triggerElement: React.createElement(IconButton, { skin: "inverted", priority: "primary", size: "tiny", dataHook: "manage-apps-more-button" },
                React.createElement(More, null)) },
            isActionRequiredApp && (React.createElement(PopoverMenu.MenuItem, { dataHook: "manage-apps-context-menu-open", prefixIcon: React.createElement(ArrowRightSmall, null), skin: "dark", text: t('manage-apps.context-menu.open'), onClick: function () {
                    sendContextMenuActionBi(app, origin, msid, 'open_app', editorType);
                    openApp(app);
                } })),
            getAppSettingsPageUrl(app) &&
                canUsePremiumApp(app, siteIsPremium) && (React.createElement(PopoverMenu.MenuItem, { dataHook: "manage-apps-context-menu-setting-page-url", prefixIcon: React.createElement(EditSmall, null), skin: "dark", text: t('manage-apps.context-menu.edit-script'), onClick: function () {
                    sendContextMenuActionBi(app, origin, msid, 'edit_settings', editorType);
                    openSettingsUrl(app, openModal, embeddedScriptAppsStatus);
                } })),
            isEmbeddedScriptApp(app) && canUsePremiumApp(app, siteIsPremium) && (React.createElement(PopoverMenu.MenuItem, { dataHook: "manage-apps-context-menu-embedded-toggle", prefixIcon: getSmallEmbeddedIcon(app.webSolutionBase.id, embeddedScriptAppsStatus), skin: "dark", text: t(getNewEmbeddedKey(app.webSolutionBase.id, embeddedScriptAppsStatus)), onClick: function () {
                    sendContextMenuActionBi(app, origin, msid, "embedded_script", editorType);
                    toggleEmbeddedStatus(app, embeddedScriptAppsStatus, updateEmbeddedScriptAppsStatus, getAppInstance, openModal);
                } })),
            !!shouldShowAddAgain(app, origin) && (React.createElement(PopoverMenu.MenuItem, { skin: "dark", dataHook: "manage-apps-context-menu-add-again", prefixIcon: React.createElement(AddSmall, null), text: t('manage-apps.context-menu.add-again'), onClick: function () {
                    sendContextMenuActionBi(app, origin, msid, 'add_again', editorType);
                    addAppAgain(app.webSolutionBase.id, app.installedVersion);
                } })),
            React.createElement(PopoverMenu.MenuItem, { skin: "dark", dataHook: "manage-apps-context-menu-app-info", prefixIcon: React.createElement(InfoCircleSmall, null), text: t('manage-apps.context-menu.app-info'), onClick: function () {
                    sendContextMenuActionBi(app, origin, msid, 'app-info', editorType);
                    gotoWebSolutionPage(app.webSolutionBase.slug);
                } }),
            app.group !== AppGroup.PENDING && !editReview && (React.createElement(PopoverMenu.MenuItem, { skin: "dark", dataHook: "manage-apps-context-menu-rate", prefixIcon: React.createElement(FavoriteSmall, null), text: t('manage-apps.context-menu.rate-review'), onClick: function () {
                    sendContextMenuActionBi(app, origin, msid, "rate_app", editorType);
                    openPostRateModal(app, openModal);
                } })),
            app.group !== AppGroup.PENDING && editReview && (React.createElement(PopoverMenu.MenuItem, { skin: "dark", dataHook: "manage-apps-context-menu-edit-review", prefixIcon: React.createElement(FavoriteSmall, null), text: t('manage-apps.context-menu.edit-review'), onClick: function () {
                    sendContextMenuActionBi(app, origin, msid, "edit_review", editorType);
                    openEditRateModal(app, openModal);
                } })),
            React.createElement(PopoverMenu.Divider, { key: 'manage-apps-context-menu-support-mail-divider' }),
            (app.supportMail || app.supportEmails) && (React.createElement(PopoverMenu.MenuItem, { skin: "dark", key: 'manage-apps-context-menu-support-mail', prefixIcon: React.createElement(EmailSmall, null), dataHook: "manage-apps-context-menu-support-mail", text: madeByWix
                    ? t('manage-apps.context-menu.support-title-wix')
                    : t('manage-apps.context-menu.support-title'), onClick: function () {
                    sendContextMenuActionBi(app, origin, msid, 'contact_us', editorType);
                    sentSupportMail(app, origin, msid, openModal, experiments);
                } })),
            isBundleApp(app) && (React.createElement(PopoverMenu.MenuItem, { skin: "dark", key: 'manage-apps-context-menu-dismiss-bundle', prefixIcon: React.createElement(HiddenSmall, null), dataHook: "manage-apps-context-menu-dismiss-bundle", text: t('manage-apps.context-menu.hide'), onClick: function () {
                    sendContextMenuActionBi(app, origin, msid, 'dismiss-bundle', editorType);
                    dismissBundleApp(app.webSolutionBase.id, deleteAppFromBundle);
                } })),
            React.createElement(PopoverMenu.MenuItem, { disabled: !isPermittedToDelete(app, permissions), dataHook: "manage-apps-context-menu-delete", prefixIcon: React.createElement(DeleteSmall, null), skin: "dark", text: t(getDeleteTextKey(app, experiments, editorType)), onClick: function () {
                    sendContextMenuActionBi(app, origin, msid, 'delete_app', editorType);
                    handleDeleteApp(app, openModal, origin, msid, deleteApp, editorType);
                } }))));
});
//# sourceMappingURL=context-menu-button.js.map